/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {parseDate} from 'shared/web';

import {
  GetServiceCaseIntegrationsClaraClaimApiResponse,
  GetServiceCaseIntegrationsClaraClaimDetailApiResponse,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
  GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponse,
  GetServiceOrderIntegrationsMazdaClaimApiResponse,
  GetServiceOrderIntegrationsMazdaClaimDetailApiResponse,
  GetServiceOrderIntegrationsMazdaPreauthorizationApiResponse,
  GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiResponse,
  GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponse,
  GetVehicleServiceChecklistsApiResponse,
  PostServiceOrderIntegrationsMazdaClaimSendApiResponse,
  PostVehicleServiceChecklistApiResponse,
} from '../types';

export const mazdaAdditionalInformationEmptyMockResponse: GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponse =
  {
    assemblyGroup: null,
    subAssemblyGroup: null,
    pncCode: null,
    symptomCode: null,
    damageCode: null,
    locationCodes: [],
    dtcCodes: [],
    causalPartNumber: null,
    isEditable: true,
  };

export const mazdaAdditionalInformationFilledMockResponse: GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponse =
  {
    assemblyGroup: 'A',
    subAssemblyGroup: 'A01',
    pncCode: 'PNC123',
    symptomCode: '01',
    damageCode: '91',
    locationCodes: ['FRT', 'RER'],
    dtcCodes: ['A1234'],
    causalPartNumber: null,
    isEditable: true,
  };

export const mazdaAdditionalInformationReadOnlyMockResponse: GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponse =
  {
    assemblyGroup: 'A',
    subAssemblyGroup: 'A01',
    pncCode: 'PNC123',
    symptomCode: '01',
    damageCode: '91',
    locationCodes: ['FRT'],
    dtcCodes: ['A1234'],
    causalPartNumber: null,
    isEditable: false,
  };

export const workItemMazdaAdditionalInformationEmptyMockResponse: GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponse =
  {
    repairDescription: null,
    invoiceNumber: null,
    invoiceDate: null,
    invoiceCompanyName: null,
  };

export const workItemMazdaAdditionalInformationFilledMockResponse: GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponse =
  {
    repairDescription: 'A1',
    invoiceNumber: 'INV-2026-001',
    invoiceDate: '2026-07-01',
    invoiceCompanyName: 'Body Shop s.r.o.',
  };

export const evaClaimAdditionalInformationEmptyMockResponse: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse =
  {
    damageCode: null,
    isPartClaimDamage: false,
    partClaimData: null,
  };

export const evaClaimAdditionalInformationFilledMockResponse: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse =
  {
    damageCode: 'DMG1234',
    isPartClaimDamage: true,
    partClaimData: {
      installationDate: parseDate('2024-01-15'),
      installationMileage: 50000,
      replacedByDealer: 'Dealer123',
      replacedPartNumber: 'PART567',
    },
  };

export const evaClaimAdditionalInformationWithoutPartClaimMockResponse: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse =
  {
    damageCode: 'DMG7890',
    isPartClaimDamage: false,
    partClaimData: null,
  };

export const claraClaimVehicleMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse = {
  claimType: '0',
  repairStartDate: '2024-01-15',
  mileageStart: 50000,
  repairEndDate: '2024-01-20',
  mileageEnd: 50100,
  partPurchaseDate: null,
  mileagePartPurchase: null,
  partNumber: null,
  attachments: [],
};

export const claraClaimPartMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse = {
  claimType: '1',
  repairStartDate: '2024-02-01',
  mileageStart: 60000,
  repairEndDate: '2024-02-05',
  mileageEnd: 60200,
  partPurchaseDate: '2024-01-10',
  mileagePartPurchase: 55000,
  partNumber: 'PART-123',
  attachments: [
    {
      fileId: 'file-1',
      filename: 'invoice.pdf',
      contentType: 'application/pdf',
    },
    {
      fileId: 'file-2',
      filename: 'damage-photo.jpeg',
      contentType: 'image/jpeg',
    },
  ],
};

export const claraClaimEmptyMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse = {
  claimType: '',
  repairStartDate: '',
  mileageStart: null,
  repairEndDate: '',
  mileageEnd: null,
  partPurchaseDate: null,
  mileagePartPurchase: null,
  partNumber: null,
  attachments: [],
};

export const claraClaimWithAttachmentsMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse =
  {
    claimType: '0',
    repairStartDate: '2024-03-01',
    mileageStart: 70000,
    repairEndDate: '2024-03-05',
    mileageEnd: 70100,
    partPurchaseDate: null,
    mileagePartPurchase: null,
    partNumber: null,
    attachments: [
      {
        fileId: 'existing-file-1',
        filename: 'warranty-doc.pdf',
        contentType: 'application/pdf',
      },
      {
        fileId: 'existing-file-2',
        filename: 'part-photo.png',
        contentType: 'image/png',
      },
    ],
  };

export const claraClaimDetailMockResponse: GetServiceCaseIntegrationsClaraClaimDetailApiResponse = {
  claimNumber: 'CLR-2024-001',
  claimType: '0',
  status: 'APPROVED',
  statusLevel: 'success',
  repairStartDate: '2024-01-15',
  mileageStart: 50000,
  repairEndDate: '2024-01-20',
  mileageEnd: 50100,
  partPurchaseDate: null,
  mileagePartPurchase: null,
  partNumber: null,
  issues: [],
  attachments: [
    {
      fileId: 'detail-file-1',
      filename: 'claim-report.pdf',
      contentType: 'application/pdf',
    },
  ],
};

export const claraClaimDetailWithIssuesMockResponse: GetServiceCaseIntegrationsClaraClaimDetailApiResponse =
  {
    claimNumber: 'CLR-2024-002',
    claimType: '1',
    status: 'RETURNED',
    statusLevel: 'warning',
    repairStartDate: '2024-02-01',
    mileageStart: 60000,
    repairEndDate: '2024-02-05',
    mileageEnd: 60200,
    partPurchaseDate: '2024-01-10',
    mileagePartPurchase: 55000,
    partNumber: 'PART-123',
    issues: [
      {level: 'warning', content: 'Missing documentation for part replacement'},
      {level: 'error', content: 'Mileage discrepancy detected'},
    ],
    attachments: [
      {
        fileId: 'detail-file-2',
        filename: 'part-invoice.pdf',
        contentType: 'application/pdf',
      },
      {
        fileId: 'detail-file-3',
        filename: 'damage.jpeg',
        contentType: 'image/jpeg',
      },
    ],
  };

export const mazdaPreauthorizationDetailMockResponse: GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiResponse =
  {
    cached: false,
    externalId: '372882332',
    externalStatus: 'NEW',
    externalStatusDescription: 'New',
    nextActor: 'mazda',
    scope: 'warranty',
    warrantyType: 'basic_warranty',
    mileage: 38800,
    vehicleServicedAccordingToManufacturerSpecs: true,
    repairDate: '2024-06-20T10:00:00Z',
    installationDate: null,
    installationMileage: null,
    installationRepairNo: null,
    causalPart: null,
    specialCausalPart: null,
    message: null,
    assessmentCodes: [
      {
        code: 'T0A',
        description: 'Test dealer claim - to be denied',
        additionalInformation: 'F1160000000000000011',
      },
      {
        code: 'BKG',
        description: 'TOTAL CLAIM VALUE IS ZERO',
        additionalInformation: '948278823',
      },
      {
        code: 'KAC',
        description: 'EXCEED BASIC WTY TERM. IF RPR/RGST DATE WAS INCORRECT, AMEND DATA',
        additionalInformation: '20220607',
      },
    ],
    decision: {
      overall: {
        totalRequestedAmount: 12000,
        totalAgreedAmount: 10000,
        totalRequestedAmountParts: 5000,
        totalAgreedAmountParts: 3000,
        totalRequestedAmountLabour: 4000,
        totalAgreedAmountLabour: 4000,
        totalRequestedAmountSublets: 1000,
        totalAgreedAmountSublets: 1000,
      },
      items: [
        {
          type: 'Part',
          catalogNumber: '5555DF001',
          sequenceNumber: 1,
          requestedQuantity: 1,
          agreedQuantity: 1,
          requestedAmount: 3000,
          agreedAmount: 3000,
        },
        {
          type: 'Part',
          catalogNumber: 'A0106AAX',
          sequenceNumber: 2,
          requestedQuantity: 1,
          agreedQuantity: 0,
          requestedAmount: 2000,
          agreedAmount: 0,
        },
        {
          type: 'Labour',
          catalogNumber: '5555DF001',
          sequenceNumber: 3,
          requestedQuantity: 1,
          agreedQuantity: 1,
          requestedAmount: 5000,
          agreedAmount: 5000,
        },
        {
          type: 'Sublet',
          catalogNumber: 'A0106AAX',
          sequenceNumber: 4,
          requestedQuantity: 1,
          agreedQuantity: 1,
          requestedAmount: 2000,
          agreedAmount: 2000,
        },
      ],
    },
  };

export const mazdaPreauthorizationDetailPendingMockResponse: GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiResponse =
  {
    cached: true,
    externalId: '372882333',
    externalStatus: 'PENDING',
    externalStatusDescription: 'Pending',
    nextActor: 'mazda',
    scope: 'goodwill',
    warrantyType: 'part_warranty',
    mileage: null,
    vehicleServicedAccordingToManufacturerSpecs: null,
    repairDate: null,
    installationDate: null,
    installationMileage: null,
    installationRepairNo: null,
    causalPart: null,
    specialCausalPart: null,
    message: null,
    assessmentCodes: [],
    decision: {
      overall: {
        totalRequestedAmount: 12000,
        totalAgreedAmount: null,
        totalRequestedAmountParts: 5000,
        totalAgreedAmountParts: null,
        totalRequestedAmountLabour: 4000,
        totalAgreedAmountLabour: null,
        totalRequestedAmountSublets: 3000,
        totalAgreedAmountSublets: null,
      },
      items: [
        {
          type: 'Part',
          catalogNumber: '5555DF001',
          sequenceNumber: 1,
          requestedQuantity: 1,
          agreedQuantity: null,
          requestedAmount: 5000,
          agreedAmount: null,
        },
      ],
    },
  };

export const mazdaPreauthorizationDraftMockResponse: GetServiceOrderIntegrationsMazdaPreauthorizationApiResponse =
  {
    externalId: 'N/A',
    externalStatus: null,
    scope: null,
    warrantyType: null,
    mileage: 38800,
    vehicleServicedAccordingToManufacturerSpecs: true,
    installationDate: null,
    installationMileage: null,
    installationRepairNo: null,
    causalPart: null,
    specialCausalPart: null,
    message: null,
    assessmentCodes: [],
    decision: null,
  };

export const mazdaPreauthorizationSavedDraftMockResponse: GetServiceOrderIntegrationsMazdaPreauthorizationApiResponse =
  {
    externalId: 'N/A',
    externalStatus: null,
    scope: 'goodwill',
    warrantyType: 'part_warranty',
    mileage: 41200,
    vehicleServicedAccordingToManufacturerSpecs: false,
    installationDate: '2024-05-14',
    installationMileage: 22100,
    installationRepairNo: 'RO-2024-0512',
    causalPart: null,
    specialCausalPart: 'B0101H',
    message: 'Customer reports oil leak after the previous repair.',
    assessmentCodes: [],
    decision: null,
  };

export const mazdaClaimDraftMockResponse: GetServiceOrderIntegrationsMazdaClaimApiResponse = {
  externalId: 'N/A',
  externalStatus: null,
  scope: null,
  warrantyType: null,
  mileage: 38800,
  repairDate: '2026-03-24',
  vehicleServicedAccordingToManufacturerSpecs: true,
  installationDate: null,
  installationMileage: null,
  installationRepairNo: null,
  causalPart: 'BPYK57K00',
  specialCausalPart: null,
  message: null,
  campaignNumber: null,
  campaignVariantNumber: null,
};

export const mazdaClaimSavedDraftMockResponse: GetServiceOrderIntegrationsMazdaClaimApiResponse = {
  externalId: 'N/A',
  externalStatus: null,
  scope: 'goodwill',
  warrantyType: 'part_warranty',
  mileage: 41200,
  repairDate: '2026-03-25',
  vehicleServicedAccordingToManufacturerSpecs: false,
  installationDate: '2026-02-10',
  installationMileage: 39000,
  installationRepairNo: 'RO-2026-0091',
  causalPart: null,
  specialCausalPart: 'B0101H',
  message: 'Customer reports oil leak after the previous repair.',
  campaignNumber: null,
  campaignVariantNumber: null,
};

export const mazdaClaimCampaignMockResponse: GetServiceOrderIntegrationsMazdaClaimApiResponse = {
  externalId: 'N/A',
  externalStatus: null,
  scope: 'tsc',
  warrantyType: null,
  mileage: 38800,
  repairDate: '2026-03-24',
  vehicleServicedAccordingToManufacturerSpecs: true,
  installationDate: null,
  installationMileage: null,
  installationRepairNo: null,
  causalPart: 'BPYK57K00',
  specialCausalPart: null,
  message: null,
  campaignNumber: 'AM026A',
  campaignVariantNumber: 1,
};

export const mazdaClaimSendMockResponse: PostServiceOrderIntegrationsMazdaClaimSendApiResponse = {
  cached: false,
  externalId: '00176',
  externalStatus: 'CLAIM_TO_WORK',
  externalStatusDescription: null,
  nextActor: null,
  scope: 'warranty',
  campaignNumber: null,
  campaignVariantNumber: null,
  warrantyType: 'basic_warranty',
  mileage: 38800,
  vehicleServicedAccordingToManufacturerSpecs: true,
  repairDate: '2026-03-24',
  installationDate: null,
  installationMileage: null,
  installationRepairNo: null,
  causalPart: 'BPYK57K00',
  specialCausalPart: null,
  message: null,
  assessmentCodes: [],
  warnings: [{code: 'W-01', description: 'Labour time exceeds the standard for this operation.'}],
  errors: [{code: 'E-07', description: 'Sublet invoice number is missing.'}],
  decision: null,
};

export const mazdaClaimDetailMockResponse: GetServiceOrderIntegrationsMazdaClaimDetailApiResponse =
  {
    cached: false,
    externalId: '00184',
    externalStatus: 'ACCEPTED',
    externalStatusDescription: 'In work',
    nextActor: 'dealer',
    campaignNumber: null,
    campaignVariantNumber: null,
    scope: 'warranty',
    warrantyType: 'basic_warranty',
    mileage: 38800,
    vehicleServicedAccordingToManufacturerSpecs: true,
    repairDate: '2026-03-17',
    installationDate: null,
    installationMileage: null,
    installationRepairNo: null,
    causalPart: '5555AU001',
    specialCausalPart: null,
    message: null,
    assessmentCodes: [
      {
        code: 'T0A',
        description: 'Test dealer claim - to be denied',
        additionalInformation: 'F1160000000000000011',
      },
      {
        code: 'BKG',
        description: 'TOTAL CLAIM VALUE IS ZERO',
        additionalInformation: '948278823',
      },
    ],
    decision: {
      overall: {
        totalRequestedAmount: 12000,
        totalAgreedAmount: 10000,
        totalRequestedAmountParts: 5000,
        totalAgreedAmountParts: 3000,
        totalRequestedAmountLabour: 4000,
        totalAgreedAmountLabour: 4000,
        totalRequestedAmountSublets: 1000,
        totalAgreedAmountSublets: 1000,
      },
      items: [
        {
          type: 'Part',
          catalogNumber: '5555DF001',
          sequenceNumber: 1,
          requestedQuantity: 1,
          agreedQuantity: 1,
          requestedAmount: 3000,
          agreedAmount: 3000,
        },
        {
          type: 'Part',
          catalogNumber: 'A0106AAX',
          sequenceNumber: 2,
          requestedQuantity: 1,
          agreedQuantity: 0,
          requestedAmount: 2000,
          agreedAmount: 0,
        },
        {
          type: 'Labour',
          catalogNumber: '5555DF001',
          sequenceNumber: 3,
          requestedQuantity: 1,
          agreedQuantity: 1,
          requestedAmount: 5000,
          agreedAmount: 5000,
        },
        {
          type: 'Sublet',
          catalogNumber: 'A0106AAX',
          sequenceNumber: 4,
          requestedQuantity: 1,
          agreedQuantity: 1,
          requestedAmount: 2000,
          agreedAmount: 2000,
        },
      ],
    },
  };

export const mazdaClaimDetailCampaignMockResponse: GetServiceOrderIntegrationsMazdaClaimDetailApiResponse =
  {
    cached: false,
    externalId: '00185',
    externalStatus: 'ACCEPTED',
    externalStatusDescription: 'In work',
    nextActor: 'gateway',
    campaignNumber: 'AP016A',
    campaignVariantNumber: 7,
    scope: 'tsc',
    warrantyType: 'basic_warranty',
    mileage: 41200,
    vehicleServicedAccordingToManufacturerSpecs: true,
    repairDate: '2026-04-02',
    installationDate: null,
    installationMileage: null,
    installationRepairNo: null,
    causalPart: '5555AU001',
    specialCausalPart: null,
    message: null,
    assessmentCodes: [],
    decision: null,
  };

export const vehicleServiceChecklistsMockResponse: GetVehicleServiceChecklistsApiResponse = {
  checklistDefinition: [
    {id: 101, name: 'Annual service checklist', description: 'Standard annual service inspection'},
    {id: 102, name: 'EV battery checklist', description: 'High-voltage battery inspection'},
  ],
  count: 2,
};

export const vehicleServiceChecklistsEmptyMockResponse: GetVehicleServiceChecklistsApiResponse = {
  checklistDefinition: [],
  count: 0,
};

export const vehicleServiceChecklistCreatedMockResponse: PostVehicleServiceChecklistApiResponse = {
  id: 'mazda-checklist-id-1',
};

export const mazdaClaimDetailPendingMockResponse: GetServiceOrderIntegrationsMazdaClaimDetailApiResponse =
  {
    cached: true,
    externalId: '00186',
    externalStatus: 'PENDING',
    externalStatusDescription: null,
    nextActor: null,
    campaignNumber: null,
    campaignVariantNumber: null,
    scope: 'goodwill',
    warrantyType: 'part_warranty',
    mileage: null,
    vehicleServicedAccordingToManufacturerSpecs: null,
    repairDate: null,
    installationDate: null,
    installationMileage: null,
    installationRepairNo: null,
    causalPart: null,
    specialCausalPart: null,
    message: null,
    assessmentCodes: [],
    decision: {
      overall: {
        totalRequestedAmount: 12000,
        totalAgreedAmount: null,
        totalRequestedAmountParts: 5000,
        totalAgreedAmountParts: null,
        totalRequestedAmountLabour: 4000,
        totalAgreedAmountLabour: null,
        totalRequestedAmountSublets: 3000,
        totalAgreedAmountSublets: null,
      },
      items: [
        {
          type: 'Part',
          catalogNumber: '5555DF001',
          sequenceNumber: 1,
          requestedQuantity: 1,
          agreedQuantity: null,
          requestedAmount: 5000,
          agreedAmount: null,
        },
      ],
    },
  };
